module.exports = __webpack_public_path__ + "img/646274.d4b25548.svg";